import { Controller } from "@hotwired/stimulus";

// Moves the subscription metadata (day pill / expiry / Plan Details) into the
// AG Grid SSRM toolbar so it sits on the same row as the plan-name <h2>, to its
// right and before the Export button. The grid's toolbar_start slot only renders
// a single node reliably, so we relocate the rich metadata here after the grid
// markup is present — same approach as the admin ResultHeader component.
export default class extends Controller {
  static targets = ["subscriptionMeta"];

  declare readonly subscriptionMetaTarget: HTMLElement;
  declare readonly hasSubscriptionMetaTarget: boolean;

  connect() {
    this.inject();
  }

  private inject() {
    if (!this.hasSubscriptionMetaTarget) return;

    const titleGroup = this.element.querySelector<HTMLElement>(
      ".ag-grid-component-title-group",
    );
    if (!titleGroup) return;

    const meta = this.subscriptionMetaTarget;
    // Place right after the plan-name heading, before Export/other toolbar items.
    const title = titleGroup.querySelector(".billing-history-title");
    if (title) {
      title.after(meta);
    } else {
      titleGroup.prepend(meta);
    }
    meta.hidden = false;
  }
}
